<template>
  <div>
    <p class="mb-2">
      Заезды <player-link :playerId="playerId">игрока {{playerId}}</player-link>
      в раже {{rushId}}.
    </p>

    <table v-if="isRacesVisible" class="table table-bordered text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col" rowspan="2">Заезд</th>
          <th scope="col" colspan="6" class="text-center">Игрок</th>
        </tr>
        <tr>
          <th scope="col">участие</th>
          <th scope="col">присоединение</th>
          <th scope="col">выход</th>
          <th scope="col">очки</th>
          <th scope="col">место</th>
          <th scope="col">участник заезда</th>
        </tr>
      </thead>
      <tr
        v-for="race in races"
        :key="race.id"
      >
        <td>
          <rush-race-link :rushRaceId="createRushRaceId(race.rushId, race.raceId)" label="заезд"/>
        </td>
        <td :class="getParticipantStateClass(race.state)">
          {{ race.state | getParticipantStateName }}
        </td>
        <td>
          {{ race.joinTime | getMomentStr }}
        </td>
        <td>
          {{ race.leaveTime | getMomentStr }}
        </td>
        <td class="text-right">{{ race.score }}</td>
        <td class="text-right">{{ race.place }}</td>
        <td>
          <rush-race-player-link :rushRaceId="createRushRaceId(race.rushId, race.raceId)" :playerId="playerId">
            участник заезда
          </rush-race-player-link>
        </td>
      </tr>
    </table>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { getParticipantStateName  } from '../model/rush_participant.js';
import { getParticipantStateClass } from '../model/rush_participant.js';

import PlayerLink from './PlayerLink.vue';
import LoadingIndicator from './LoadingIndicator.vue';
import RushRaceLink from './RushRaceLink.vue';
import RushRacePlayerLink from './RushRacePlayerLink.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'RushPlayerRaces',

  components: {
    PlayerLink,
    LoadingIndicator,
    RushRaceLink,
    RushRacePlayerLink,
  },

  props: {
    rushPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {number} */
    rushId() {
      return this.rushPlayerId.rushId;
    },

    /** @returns {number} */
    playerId() {
      return this.rushPlayerId.playerId;
    },

    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {boolean} */
    isRacesVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const races = this.races;
      if(races === null) {
        return false;
      }

      return races.length > 0;
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?Array} */
      races: null,
    };
  },

  created() {
    this.loadRaces();
  },

  methods: {
    loadRaces() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const rushId = this.rushId;
      const playerId = this.playerId;
      const url = `/rush/${rushId}/player/${playerId}/races`;

      HTTP.get(url)
      .then(response => {
        this.races = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    /**
     * @param {number} rushId
     * @param {number} raceId
     */
    createRushRaceId(rushId, raceId) {
      return {
        rushId: rushId,
        raceId: raceId,
      };
    },

    getParticipantStateClass,
  },

  filters: {
    getParticipantStateName,
  },
};
</script>
